import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length > 0)?_c('validation-badge',{attrs:{"errors":_vm.errors}},[_c(VIcon,{attrs:{"color":"error"}},[_vm._v("mdi-alert-circle-outline")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }